/* eslint-disable prettier/prettier */
export const formatFileSize = (bytes?: number): string => {
	if (!bytes) return '0 B';
	console.log('Formatting bytes:', bytes);
	const k = 1024;
	const sizes = ['B', 'KB', 'MB', 'GB'];
	const i = Math.floor(Math.log(bytes) / Math.log(k));
	console.log('Calculated size index:', i);
	return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`;
};
